export class CollectionType{
    collectionTypcode: string
    portfolioId: number
}